import { on } from "delegated-events";
import datepicker from "@common/scripts/components/datepicker";
import dropdown from "@common/scripts/components/dropdown";
import fileUpload from "@frontend/scripts/components/file-upload";
import maskFields from "@common/scripts/components/mask-fields";
import toggleFields from "@common/scripts/components/toggle-fields";

export default {
  init: () => {
    datepicker.init();
    dropdown.init();
    fileUpload.init();

    document.querySelectorAll(".styled-form").forEach((form) => {
      maskFields.init(form);
      toggleFields.init(form);

      if (form.classList.contains("styled-form-edit-toggle")) {
        form.querySelectorAll(".edit-toggle-field").forEach((field) => {
          field.setAttribute("readonly", "readonly");
        });
      }
    });

    on("click", "[data-edit-form-toggle]", (e) => {
      const button = e.target.closest("[data-edit-form-toggle]");
      const formId = button.dataset.editFormToggle;
      const form = document.getElementById(formId);

      if (form) {
        if (button.getAttribute("aria-pressed") === "true") {
          button.setAttribute("aria-pressed", "false");

          form.querySelectorAll(".edit-toggle-field").forEach((field) => {
            field.setAttribute("readonly", "readonly");
          });
        } else {
          button.setAttribute("aria-pressed", "true");

          form.querySelectorAll(".edit-toggle-field[readonly]").forEach((field) => {
            field.removeAttribute("readonly");
          });
        }
      }
    });

    on(
      "focus",
      "input",
      (e) => {
        if ("ontouchstart" in document.documentElement) {
          setTimeout(function () {
            const inputRect = e.target.getBoundingClientRect();
            const absoluteElementTop = inputRect.top + window.scrollY - inputRect.height;

            window.scrollTo({
              top: absoluteElementTop,
              behavior: "smooth",
            });
          }, 125);
        }
      },
      { capture: true },
    );
  },
};
